/* ──────────────────────────────────────────────
   Company identity — the single source for the footer,
   About page and legal pages. Values match the public
   ANAF record (checked 21 October 2026).
   ────────────────────────────────────────────── */
export const COMPANY = {
  legalName: "Intense Technologies S.R.L.",
  tradingName: "Paybank2bank",
  legalForm: "Romanian limited liability company",
  address: "Nivel 5, Calea Plevnei 53, 010223 București, Romania",
  tradeRegister: "J2024021111008",
  cui: "50523103",
  // Share capital in RON — required on the website by Law 31/1990 art. 74
  shareCapital: "500",
  email: "team@paybank2bank.io",
  techEmail: "tech@paybank2bank.io",
};

export const REGULATORY_LINE =
  "Paybank2bank is a technology provider, not a bank or payment institution, and never holds your money. " +
  "Payment initiation and account information services are provided by our regulated providers, " +
  "under their own authorisation.";
